import {useNavigate, useParams} from "react-router-dom";
import {useEffect} from "react";
import {Result} from "antd";
import {useAuthenticationFromRiskappMutation} from "../redux/api/authApiSlice";
import {useLogout} from "../hooks/useLogout";

export default function TransitionFromRiskApp() {

  let {token} = useParams()
  const navigate = useNavigate()
  const [authFromRiskapp] = useAuthenticationFromRiskappMutation()
  const {logout} = useLogout()

  useEffect(() => {
    const validateToken = async () => {
      if (token) {
        try {
          await authFromRiskapp({uuid: token}).unwrap()
          navigate('/')
        } catch (e) {
          //todo navigate back to customers
          void logout()
        }
      }
    }
    void validateToken()
  }, [authFromRiskapp, logout, navigate, token])


  return <>
    {!token && <Result status={"error"} title={'Credenziali non corrette'}
                       subTitle={'Token di autenticazione non presente'}/>}
  </>
}